import { render, staticRenderFns } from "./CurrentStage.vue?vue&type=template&id=7bf8833c&scoped=true&"
import script from "./CurrentStage.vue?vue&type=script&lang=ts&"
export * from "./CurrentStage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf8833c",
  null
  
)

export default component.exports